import React, { useEffect, useState, lazy } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Star } from 'lucide-react';
const REVIEWS = [{
  name: 'Valentina',
  text: 'Muchas gracias por esto....',
  time: 'hace 5 minutos',
  img: 'https://images.unsplash.com/photo-1503104834685-7205e8607eb9?w=80&h=80&fit=crop&crop=face'
}, {
  name: 'Camila',
  text: 'Esto es increíble, me....',
  time: 'hace 12 minutos',
  img: 'https://images.unsplash.com/photo-1517423440428-a5a00ad493e8?w=80&h=80&fit=crop&crop=face'
}, {
  name: 'Sofía',
  text: 'Me cambió completamente....',
  time: 'hace 1 minuto',
  img: 'https://images.unsplash.com/photo-1485875437342-9b39470b3d95?w=80&h=80&fit=crop&crop=face'
}, {
  name: 'Martina',
  text: 'Gracias de verdad....',
  time: 'hace 7 minutos',
  img: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=80&h=80&fit=crop&crop=face'
}, {
  name: 'Jazmín',
  text: 'Estoy sorprendida con....',
  time: 'hace 5 minutos',
  img: 'https://images.unsplash.com/photo-1532170579297-281918c8ae72?w=80&h=80&fit=crop&crop=face'
}, {
  name: 'Lucía',
  text: 'Me encantó, súper claro....',
  time: 'hace 12 minutos',
  img: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=80&h=80&fit=crop&crop=face'
}, {
  name: 'Agustina',
  text: 'No suelo dejar mensajes, pero....',
  time: 'hace 7 minutos',
  img: 'https://images.unsplash.com/photo-1469334031218-e382a71b716b?w=80&h=80&fit=crop&crop=face'
}, {
  name: 'Micaela',
  text: 'Me ayudó muchísimo....',
  time: 'hace 1 minuto',
  img: 'https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=80&h=80&fit=crop&crop=face'
}, {
  name: 'Julieta',
  text: 'Qué increíble esto, me dio....',
  time: 'hace 5 minutos',
  img: 'https://images.unsplash.com/photo-1493666438817-866a91353ca9?w=80&h=80&fit=crop&crop=face'
}, {
  name: 'Florencia',
  text: 'Me sirvió un montón....',
  time: 'hace 12 minutos',
  img: 'https://images.unsplash.com/photo-1502323777036-f29e3972d82f?w=80&h=80&fit=crop&crop=face'
}, {
  name: 'Paula',
  text: 'Gracias, me dio mucha claridad....',
  time: 'hace 7 minutos',
  img: 'https://images.unsplash.com/photo-1554151228-14d9def656e4?w=80&h=80&fit=crop&crop=face'
}, {
  name: 'Milagros',
  text: 'Me cambió totalmente la forma....',
  time: 'hace 1 minuto',
  img: 'https://images.unsplash.com/photo-1593104547489-5cfb3839a3b5?w=80&h=80&fit=crop&crop=face'
}, {
  name: 'Catalina',
  text: 'Estoy feliz con esto, superó....',
  time: 'hace 12 minutos',
  img: 'https://images.unsplash.com/photo-1567532939604-b6b5b0db2604?w=80&h=80&fit=crop&crop=face'
}, {
  name: 'Antonella',
  text: 'Muchas gracias, sentí un....',
  time: 'hace 5 minutos',
  img: 'https://images.unsplash.com/photo-1592621385612-4d7129426394?w=80&h=80&fit=crop&crop=face'
}, {
  name: 'Brenda',
  text: 'Increíble, de verdad me ayudó....',
  time: 'hace 7 minutos',
  img: 'https://images.unsplash.com/photo-1601412436009-d964bd02edbc?w=80&h=80&fit=crop&crop=face'
}, {
  name: 'Rocío',
  text: 'Lo recomiendo muchísimo....',
  time: 'hace 1 minuto',
  img: 'https://images.unsplash.com/photo-1607746882042-944635dfe10e?w=80&h=80&fit=crop&crop=face'
}, {
  name: 'Malena',
  text: 'Gracias por esto, me hizo....',
  time: 'hace 12 minutos',
  img: 'https://images.unsplash.com/photo-1488426862026-3ee34a7d66df?w=80&h=80&fit=crop&crop=face'
}, {
  name: 'Lourdes',
  text: 'Me encantó, fue práctico, rápido....',
  time: 'hace 5 minutos',
  img: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=80&h=80&fit=crop&crop=face'
}, {
  name: 'Ailén',
  text: 'No esperaba tanto, pero la....',
  time: 'hace 7 minutos',
  img: 'https://images.unsplash.com/photo-1596215143922-eb31babd11ce?w=80&h=80&fit=crop&crop=face'
}, {
  name: 'Carolina',
  text: 'Me ayudó muchísimo, siento....',
  time: 'hace 1 minuto',
  img: 'https://images.unsplash.com/photo-1551836022-d5d88e9218df?w=80&h=80&fit=crop&crop=face'
}, {
  name: 'Candela',
  text: 'Esto es una locura....',
  time: 'hace 5 minutos',
  img: 'https://images.unsplash.com/photo-1614283233556-f35b0c801ef1?w=80&h=80&fit=crop&crop=face'
}, {
  name: 'Belén',
  text: 'Gracias, me dio resultados....',
  time: 'hace 12 minutos',
  img: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=80&h=80&fit=crop&crop=face'
}, {
  name: 'Abril',
  text: 'Me cambió completamente....',
  time: 'hace 7 minutos',
  img: 'https://images.unsplash.com/photo-1517841905240-472988babdf9?w=80&h=80&fit=crop&crop=face'
}, {
  name: 'Tatiana',
  text: 'Súper recomendado, me ayudó....',
  time: 'hace 1 minuto',
  img: 'https://images.unsplash.com/photo-1500917293891-ef795e70e1f6?w=80&h=80&fit=crop&crop=face'
}, {
  name: 'Nazarena',
  text: 'Muchas gracias por esto....',
  time: 'hace 12 minutos',
  img: 'https://images.unsplash.com/photo-1499714608240-22fc6ad53fb2?w=80&h=80&fit=crop&crop=face'
}];
const MAX_REVIEWS = 3399;
function pickRandomReview(prevName?: string) {
  let r = REVIEWS[Math.floor(Math.random() * REVIEWS.length)];
  let attempts = 0;
  while (prevName && r.name === prevName && attempts < 5) {
    r = REVIEWS[Math.floor(Math.random() * REVIEWS.length)];
    attempts++;
  }
  return r;
}
function pickRandomRating() {
  // Range 4.70 → 4.85 inclusive, step 0.01
  const min = 470;
  const max = 485;
  const v = Math.floor(Math.random() * (max - min + 1)) + min;
  return v / 100;
}
function formatNumber(n: number) {
  return n.toLocaleString('es-AR');
}
function formatRating(r: number) {
  return r.toFixed(2).replace('.', ',');
}
export function StickyReviewBar() {
  const [review, setReview] = useState(() => pickRandomReview());
  const [tick, setTick] = useState(0);
  const [reviewCount, setReviewCount] = useState(3003);
  const [rating, setRating] = useState(4.83);
  const [scrolledPastFold, setScrolledPastFold] = useState(false);
  const [inOfferSection, setInOfferSection] = useState(false);
  // Rotate review every 5s
  useEffect(() => {
    const id = setInterval(() => {
      setReview(prev => pickRandomReview(prev.name));
      setTick(t => t + 1);
    }, 5000);
    return () => clearInterval(id);
  }, []);
  // Increment review count every 3s by random 1-4, capped at MAX_REVIEWS
  useEffect(() => {
    const id = setInterval(() => {
      setReviewCount(c => Math.min(c + (Math.floor(Math.random() * 4) + 1), MAX_REVIEWS));
    }, 3000);
    return () => clearInterval(id);
  }, []);
  // Rotate rating every 10s within [4.70, 4.85]
  useEffect(() => {
    const id = setInterval(() => {
      setRating(prev => {
        let next = pickRandomRating();
        let attempts = 0;
        while (next === prev && attempts < 5) {
          next = pickRandomRating();
          attempts++;
        }
        return next;
      });
    }, 10000);
    return () => clearInterval(id);
  }, []);
  // Detect scroll past above-the-fold
  useEffect(() => {
    const onScroll = () => {
      setScrolledPastFold(window.scrollY > window.innerHeight * 0.6);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  // Detect when user is inside the offer section
  useEffect(() => {
    const el = document.getElementById('oferta');
    if (!el) return;
    const observer = new IntersectionObserver(([entry]) => {
      setInOfferSection(entry.isIntersecting);
    }, {
      rootMargin: '-10% 0px -40% 0px'
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
  const ctaVisible = scrolledPastFold && !inOfferSection;
  const scrollToOffer = () => {
    const target = document.getElementById('oferta-header');
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  // Compute fractional fill of the last star from current rating
  const lastStarFillPct = Math.max(0, Math.min(100, Math.round((rating - 4) * 100)));
  return;
}